import request from "superagent";
import { getAuthHeader } from "./superagent";
import moment from "moment-timezone";
import { FirebaseAuth } from "./firebase";

export const HttpMethod = {
  GET: "GET",
  PUT: "PUT",
  POST: "POST",
  PATCH: "PATCH",
  DELETE: "DELETE",
};

const initToken = (IdTokenResult) => {
  const { token } = IdTokenResult;

  localStorage.setItem("AUTH_TOKEN", token);
};

function getUserData(token) {
  const base64Url = token.split(".")[1];
  const base64 = base64Url.replace("-", "+").replace("_", "/");
  return JSON.parse(window.atob(base64));
}

async function updateUserSession(forceRefresh = true) {
  if (!FirebaseAuth.currentUser) {
    return;
  }
  const IdTokenResult = await FirebaseAuth.currentUser.getIdTokenResult(forceRefresh);
  initToken(IdTokenResult);
  return IdTokenResult.token;
}

export async function callApi({ method, url, body = {}, query = {}, headers = {} }) {
  const authHeader = await getAuthHeader();

  /**
   * ***** WARNING ****
   *  `superagent` requires Authorization to either be a string, or null
   * DO NOT SET `Authorization` to `undefined` because you will break sign in flow
   * See https://app.datadoghq.com/incidents/102
   */
  // FIXME: Automatically disabled during ESLint config update
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let authToken: any = localStorage.getItem("AUTH_TOKEN");
  let data;
  let startTime: string;
  let loginDuration;
  const sessionDuration = 50;
  const now = moment();

  if (authToken) {
    data = getUserData(authToken);
    startTime = moment.unix(data.iat);
    loginDuration = now.diff(startTime, "minutes");
  }

  if (!authToken || loginDuration >= sessionDuration) {
    authToken = await updateUserSession();
  }
  /**
   * ***** WARNING ****
   *  `superagent` requires Authorization to either be a string, or null
   * DO NOT SET `Authorization` to `undefined` because you will break sign in flow
   * See https://app.datadoghq.com/incidents/102
   */
  request.agent().set("Authorization", authToken);

  const res = await request(method, url)
    .set({ ...authHeader, ...headers })
    .send(body)
    .query(query);
  return res.body;
}
